import { render, staticRenderFns } from "./SubjectLevelSelector.vue?vue&type=template&id=0b5c854e"
import script from "./SubjectLevelSelector.ts?vue&type=script&lang=ts&external"
export * from "./SubjectLevelSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./SubjectLevelSelector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports